import {Component, EventEmitter, Input, Output} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {CommentDialogComponent} from './comment-dialog.component';

@Component({
  selector: 'cm-comment-button',
  template: `
    <button mat-icon-button
            color="primary"
            *ngIf="comment || !readOnly"
            (click)="openPopup()"
            matTooltip="{{comment ? 'Read comment' : 'Write new comment'}}">
      <i class="fas fa-comment" *ngIf="comment" aria-hidden="true"></i>
      <i class="far fa-comment" *ngIf="!comment" aria-hidden="true"></i>
      <!--<span class="d-md-none">Read comment</span>-->
    </button>
  `
})
export class CommentButtonComponent {

  @Input()
  public comment: string;

  @Input()
  public readOnly = true;

  @Output()
  commentChange = new EventEmitter<string>();

  constructor(private matDialog: MatDialog) {
  }

  openPopup() {
    this.matDialog.open(CommentDialogComponent, <MatDialogConfig> {
      data: {
        comment: this.comment,
        readOnly: this.readOnly
      },
      width: '400px'
    }).afterClosed().subscribe(next => {
      if (next) {
        this.commentChange.emit(next);
      }
    });
  }

}
